/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resources_Copy_Link_To_ClipboardInputs */

const en_admin_resources_copy_link_to_clipboard = /** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Link to Clipboard`)
};

const de_admin_resources_copy_link_to_clipboard = /** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren`)
};

const es_admin_resources_copy_link_to_clipboard = /** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar`)
};

const fr_admin_resources_copy_link_to_clipboard = /** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier`)
};

/** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */
const it_admin_resources_copy_link_to_clipboard = en_admin_resources_copy_link_to_clipboard;

/** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */
const pt_br2_admin_resources_copy_link_to_clipboard = en_admin_resources_copy_link_to_clipboard;

/** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */
const pl_admin_resources_copy_link_to_clipboard = en_admin_resources_copy_link_to_clipboard;

/** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */
const hu_admin_resources_copy_link_to_clipboard = en_admin_resources_copy_link_to_clipboard;

/** @type {(inputs: Admin_Resources_Copy_Link_To_ClipboardInputs) => LocalizedString} */
const ro_admin_resources_copy_link_to_clipboard = en_admin_resources_copy_link_to_clipboard;

/**
* | output |
* | --- |
* | "Copy Link to Clipboard" |
*
* @param {Admin_Resources_Copy_Link_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resources_copy_link_to_clipboard = /** @type {((inputs?: Admin_Resources_Copy_Link_To_ClipboardInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resources_Copy_Link_To_ClipboardInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resources_copy_link_to_clipboard(inputs)
	if (locale === "de") return de_admin_resources_copy_link_to_clipboard(inputs)
	if (locale === "es") return es_admin_resources_copy_link_to_clipboard(inputs)
	if (locale === "fr") return fr_admin_resources_copy_link_to_clipboard(inputs)
	if (locale === "it") return it_admin_resources_copy_link_to_clipboard(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resources_copy_link_to_clipboard(inputs)
	if (locale === "pl") return pl_admin_resources_copy_link_to_clipboard(inputs)
	if (locale === "hu") return hu_admin_resources_copy_link_to_clipboard(inputs)
	return ro_admin_resources_copy_link_to_clipboard(inputs)
});
export { admin_resources_copy_link_to_clipboard as "admin.resources.copy_link_to_clipboard" }